import React from "react";
import PropTypes from "prop-types";


class P24TransactionStatusByP24 extends React.Component {

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit();
    };


    render() {

        return (
            <div className="w3-card-4" >
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">Dane transakcji w systemie P24</h2>
                </div>

                <div className="w3-container w3-theme-l3">
                    <h5 className="w3-center">Dane transakcyjne</h5>
                </div>

                <iframe title="transaction status" src={this.props.transaction.p24UrlTransactionStatus} width="800" height="600" />

                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            Zamknij
                        </button>
                    </div>
                </form>
            </div>
        )
    }

}

P24TransactionStatusByP24.propTypes = {
    //dane wejsciowe obiektu do wypelnienia
    transaction: PropTypes.object.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired
}

export default P24TransactionStatusByP24;